import IConfig from "interfaces/IConfig";
import ProvidersTable from "./reducers/ProviderTableReducer";
import ProvidersSaga from "./saga";
import store from "rootStore";
import { routingType } from "types/configTypes";
import { registerModals } from "modals";
import ProviderCreateModal from "./modals/ProviderCreateModal";
import ProviderUpdateModal from "./modals/ProviderUpdateModal";

export const moduleName = "payment.provider";

const getConfig = () => {
    const config: IConfig = {
        active: true,
        routing: [],
        url: "",
    };

    store.reducerManager?.add("ProvidersTable", ProvidersTable);
    store.injectSaga?.("ProvidersSaga", ProvidersSaga);
    registerModals({ ProviderCreateModal, ProviderUpdateModal });

    const routing: routingType = [];

    return { config, routing };
};

export default getConfig;
